/**
 * JWT Token Module
 * 
 * Модуль для автоматического получения и обновления JWT токенов
 * Использует новый JWT сервис с поддержкой периодического обновления
 */

import { initializeJWT, startJWTRefresh } from './services/jwtService';

// Инициализируем JWT сервис при загрузке модуля с повторными попытками
initializeJWT(true).then(() => {
    // Запускаем автоматическое обновление токена каждый час
    startJWTRefresh();
    console.log('🚀 Сервис токенов инициализирован');
}).catch((error) => {
    console.error('❌ Ошибка при инициализации сервиса токенов:', error);
});
